import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "q-pa-sm" };
const _hoisted_2 = { class: "row justify-center" };
import { ref } from 'vue';
import { ReportBypassPlugin } from 'src/features/messaging/chat/components/methods/reportBypass';
import generalDialog from 'src/components/general/dialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'report',
    setup(__props) {
        const reportedDialog = ref(false);
        function reportCallback() {
            reportedDialog.value = true;
        }
        const { report } = ReportBypassPlugin(reportCallback);
        return (_ctx, _cache) => {
            const _component_q_icon = _resolveComponent("q-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "report-btn", _normalizeProps(_guardReactiveProps({ report: _unref(report) }))),
                _createVNode(generalDialog, {
                    modelValue: reportedDialog.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((reportedDialog).value = $event)),
                    title: "Success",
                    width: "400px"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_q_icon, {
                                    name: "report",
                                    color: "accent",
                                    size: "3.75rem"
                                })
                            ]),
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row justify-center q-pt-sm text-body1" }, " Host reported successfully. Please give us a few days to investigate ", -1))
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
